import type { DmPracticeOption } from '../../../../../services/practiceDm';

export const MAX_DM_PRACTICES = 11;

export function addDmPractice(
    list: DmPracticeOption[],
    practice: DmPracticeOption
): DmPracticeOption[] {
    const taken = list.some((p) => p.practiceId === practice.practiceId);
    if (taken || list.length >= MAX_DM_PRACTICES) return list;
    return [...list, practice];
}

export function setMainDmPractice(
    list: DmPracticeOption[],
    dmPracticeId: number
): DmPracticeOption[] {
    const main = list.find((p) => p.practiceId === dmPracticeId);
    if (!main) return list;
    return [main, ...list.filter((p) => p.practiceId !== dmPracticeId)];
}

// The head of the list is the doctor's main practice, so removing it promotes the next one.
export function removeDmPractice(
    list: DmPracticeOption[],
    dmPracticeId: number
): DmPracticeOption[] {
    return list.filter((p) => p.practiceId !== dmPracticeId);
}
